import { Component, OnDestroy, OnInit } from '@angular/core';
import { Customer } from '@core/models/customer.model';
import { CustomerService } from '@core/services/customer.service';
import { UserProfilesService } from '@core/services/user-profiles.service';
import { BehaviorSubject, forkJoin, map } from 'rxjs';
import { SubSink } from 'subsink';

@Component({
	selector: 'app-customers-page',
	templateUrl: './customers-page.component.html',
	styleUrls: ['./customers-page.component.css']
})
export class CustomersPageComponent implements OnInit, OnDestroy {

	readonly customers$ = new BehaviorSubject<Customer[] | undefined>(undefined);

	private subs = new SubSink();
	constructor (
		private _customerService: CustomerService,
		private _userProfileService: UserProfilesService
	) { }

	ngOnInit(): void {
		this.subs.add(
			this._userProfileService.userProfile$.subscribe({
				next: (profile) => {
					const profileCustomers: Customer[] = profile && profile.customers && profile.customers.length > 0 ? profile.customers : [];

					const clients$ = forkJoin(
						// For each customer in profile.customers
						profileCustomers
							.filter(profileCustomer => !!profileCustomer.id)
							.map(profileCustomer =>
								// get the clients of the customer
								this._customerService.getCustomers(profileCustomer.id || "") // the '|| ""' part just shushes up the code analyzer
									.pipe(
										// if the customer is agency and has any clients, then include the clients in the list, otherwise include the customer itself
										map(clients => clients.length > 0 ? clients : [profileCustomer])
									)
							)
					)
						.pipe(
							map((allCustomers: Customer[][]) => {
								const flattenedCustomers = allCustomers.flat();

								const uniqueSortedCustomers = flattenedCustomers
									.filter((customer, index) => {
										return flattenedCustomers.findIndex(c => c.id === customer.id) === index;
									})
									.sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));

								return uniqueSortedCustomers;
							})
						);

					this.subs.add(
						clients$.subscribe({
							next: (customers) => {
								this.customers$.next(customers || []);
							}
						}));
				}
			}));
	}

	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}
}
